<template>
  <v-container>
    <!-- <v-container fluid class="pa-0 ma-0">
      <v-img max-height="25vh" :src="event.header" />
    </v-container> -->
    <v-container class="pa-6 pt-10" fluid>
      <v-row>
        <v-col cols="12" class="col-md-6">
          <h1>{{ $t("Games Calendar - Edit Event") }}</h1>
        </v-col>
        <v-col cols="12" class="text-right">
          <v-btn class="" @click="dialog = true"> {{ $t("Delete") }}</v-btn>
        </v-col>
      </v-row>
    </v-container>
    <v-container fluid class="services-list">
      <v-row dense>
        <!-- manage teams -->
        <v-col class="col-sm-12 col-md-12">
          <v-card class="pa-0" flat>
            <v-card-text>
              <v-row>
                <v-col cols="12" sm="12" md="12">
                  <v-text-field
                    :label="$t('Event Name')"
                    v-model="name"
                  ></v-text-field>
                </v-col>

                <v-menu
                  ref="startOpen"
                  v-model="startOpen"
                  :close-on-content-click="false"
                  :return-value.sync="start"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-col cols="12" sm="12" md="4">
                      <v-text-field
                        v-model="start"
                        label="Start Date"
                        prepend-icon="mdi-calendar"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                      ></v-text-field>
                    </v-col>
                  </template>
                  <v-date-picker v-model="start" no-title scrollable>
                    <v-spacer></v-spacer>
                    <v-btn text color="primary" @click="startOpen = false">
                      Cancel
                    </v-btn>
                    <v-btn
                      text
                      color="primary"
                      @click="$refs.startOpen.save(start)"
                    >
                      OK
                    </v-btn>
                  </v-date-picker>
                </v-menu>

                <v-col cols="12" sm="2" md="4">
                  <v-select
                    v-model="startTime"
                    :items="timeHours"
                    label="Time Start"
                  ></v-select>
                </v-col>
                <v-col cols="12" sm="2" md="4">
                  <v-select
                    v-model="startMinutes"
                    :items="timeMinutes"
                    label="Minutes Start"
                  ></v-select>
                </v-col>

                <v-menu
                  ref="endOpen"
                  v-model="endOpen"
                  :close-on-content-click="false"
                  :return-value.sync="end"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-col cols="12" sm="6" md="4">
                      <v-text-field
                        v-model="end"
                        label="End Date"
                        prepend-icon="mdi-calendar"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                      ></v-text-field>
                    </v-col>
                  </template>
                  <v-date-picker v-model="end" no-title scrollable>
                    <v-spacer></v-spacer>
                    <v-btn text color="primary" @click="endOpen = false">
                      Cancel
                    </v-btn>
                    <v-btn
                      text
                      color="primary"
                      @click="$refs.endOpen.save(end)"
                    >
                      OK
                    </v-btn>
                  </v-date-picker>
                </v-menu>

                <v-col cols="12" sm="2" md="4">
                  <v-select
                    v-model="endTime"
                    :items="timeHours"
                    label="Time Start"
                  ></v-select>
                </v-col>
                <v-col cols="12" sm="2" md="4">
                  <v-select
                    v-model="endMinutes"
                    :items="timeMinutes"
                    label="Minutes Start"
                  ></v-select>
                </v-col>

                <v-col cols="12" sm="12" md="12">
                  <v-select
                    v-model="timeZone"
                    :items="tzStrings"
                    item-text="label"
                    item-value="value"
                    label="Time Zone"
                  ></v-select>
                </v-col>

                <v-col cols="12" sm="6" md="4">
                  <v-menu
                    ref="menuColor"
                    v-model="menuColor"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-sheet
                        v-bind="attrs"
                        v-on="on"
                        class="elevation-0"
                        height="25"
                        :color="color"
                      >
                        <pre class="pl-5"
                          >{{ $t("Event Colour") }}</pre
                        >
                      </v-sheet>
                    </template>
                    <v-color-picker
                      hide-canvas
                      hide-inputs
                      hide-mode-switch
                      hide-sliders
                      show-swatches
                      swatches-max-height="250"
                      v-model="color"
                    ></v-color-picker>
                  </v-menu>
                </v-col>
                <v-col cols="12" sm="6" md="4">
                  <v-checkbox
                    v-model="allDay"
                    :label="$t('All Day Event')"
                  ></v-checkbox>
                </v-col>
                <v-col cols="12" sm="6" md="4">
                  <v-select
                    v-model="gamesType"
                    :items="types"
                    item-text="name"
                    item-value="gameID"
                    dense
                    outlined
                    hide-details
                    class="ma-2"
                    label="Games"
                  ></v-select>
                </v-col>
                <v-col cols="12" sm="12" md="12">
                  <v-label>{{ $t("Event Description") }}</v-label>
                  <div class="editorx_body">
                    <!--editorjs id-->
                    <div class :id="`codex-editor`" />
                  </div>
                  <div class="editorx_body"></div>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" class="d-flex justify-end">
                  <v-col class="text-right">
                    <v-btn color="green lighten-2" text @click="saveEvent">
                      {{ $t("Ok") }}
                    </v-btn>
                    <v-btn color="red lighten-2" text @click="reset">
                      {{ $t("Cancel") }}
                    </v-btn>
                  </v-col>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>

    <v-dialog v-model="dialog" width="500" @keydown.esc="cancel">
      <v-card>
        <!-- <v-toolbar dark dense flat>
          <v-toolbar-title class="white--text"></v-toolbar-title>
        </v-toolbar> -->
        <v-card-text class="pa-4">{{ $t("Delete this Event?") }}</v-card-text>
        <v-card-actions class="pt-0">
          <v-spacer></v-spacer>
          <v-btn color="primary darken-1" text @click.native="deleteEvent"
            >Yes</v-btn
          >
          <v-btn color="grey" text @click.native="dialog = false">Cancel</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { firebaseApp } from "@/config/firebase";
import firebase from "firebase/app";
const db = firebase.firestore(firebaseApp);
import dateTimePicker from "../../components/datetimepicker.vue";

import EditorJS from "@editorjs/editorjs";
import Header from "@editorjs/header";
import Paragraph from "@editorjs/paragraph";
import List from "@editorjs/list";
import SimpleImage from "@editorjs/simple-image";

import { DateTime } from "luxon";
import { format } from "date-fns-tz";

export default {
  name: "Calendar_Edit",
  route: {
    path: "/calendar/edit/:eventid",
    name: "Calendar_Edit",
  },
  data: () => ({
    name: "",
    startOpen: false,
    endOpen: false,
    timeHours: [
      "00",
      "01",
      "02",
      "03",
      "04",
      "05",
      "06",
      "07",
      "08",
      "09",
      "10",
      11,
      12,
      13,
      14,
      15,
      16,
      17,
      18,
      19,
      20,
      21,
      22,
      23,
    ],
    timeMinutes: ["00", 15, 30, 45],
    startTime: "",
    startMinutes: "",
    startAMPM: "",
    endTime: "",
    endMinutes: "",
    timeZone: "",
    tzStrings: [
      {
        label: "(GMT-12:00) International Date Line West",
        value: "Etc/GMT+12",
      },
      { label: "(GMT-11:00) Midway Island, Samoa", value: "Pacific/Midway" },
      { label: "(GMT-10:00) Hawaii", value: "Pacific/Honolulu" },
      { label: "(GMT-09:00) Alaska", value: "US/Alaska" },
      {
        label: "(GMT-08:00) Pacific Time (US & Canada)",
        value: "America/Los_Angeles",
      },
      {
        label: "(GMT-08:00) Tijuana, Baja California",
        value: "America/Tijuana",
      },
      { label: "(GMT-07:00) Arizona", value: "US/Arizona" },
      {
        label: "(GMT-07:00) Chihuahua, La Paz, Mazatlan",
        value: "America/Chihuahua",
      },
      {
        label: "(GMT-07:00) Mountain Time (US & Canada)",
        value: "US/Mountain",
      },
      { label: "(GMT-06:00) Central America", value: "America/Managua" },
      { label: "(GMT-06:00) Central Time (US & Canada)", value: "US/Central" },
      {
        label: "(GMT-06:00) Guadalajara, Mexico City, Monterrey",
        value: "America/Mexico_City",
      },
      { label: "(GMT-06:00) Saskatchewan", value: "Canada/Saskatchewan" },
      {
        label: "(GMT-05:00) Bogota, Lima, Quito, Rio Branco",
        value: "America/Bogota",
      },
      { label: "(GMT-05:00) Eastern Time (US & Canada)", value: "US/Eastern" },
      { label: "(GMT-05:00) Indiana (East)", value: "US/East-Indiana" },
      { label: "(GMT-04:00) Atlantic Time (Canada)", value: "Canada/Atlantic" },
      { label: "(GMT-04:00) Caracas, La Paz", value: "America/Caracas" },
      { label: "(GMT-04:00) Manaus", value: "America/Manaus" },
      { label: "(GMT-04:00) Santiago", value: "America/Santiago" },
      { label: "(GMT-03:30) Newfoundland", value: "Canada/Newfoundland" },
      { label: "(GMT-03:00) Brasilia", value: "America/Sao_Paulo" },
      {
        label: "(GMT-03:00) Buenos Aires, Georgetown",
        value: "America/Argentina/Buenos_Aires",
      },
      { label: "(GMT-03:00) Greenland", value: "America/Godthab" },
      { label: "(GMT-03:00) Montevideo", value: "America/Montevideo" },
      { label: "(GMT-02:00) Mid-Atlantic", value: "America/Noronha" },
      { label: "(GMT-01:00) Cape Verde Is.", value: "Atlantic/Cape_Verde" },
      { label: "(GMT-01:00) Azores", value: "Atlantic/Azores" },
      {
        label: "(GMT+00:00) Casablanca, Monrovia, Reykjavik",
        value: "Africa/Casablanca",
      },
      {
        label:
          "(GMT+00:00) Greenwich Mean Time : Dublin, Edinburgh, Lisbon, London",
        value: "Etc/Greenwich",
      },
      {
        label: "(GMT+01:00) Amsterdam, Berlin, Bern, Rome, Stockholm, Vienna",
        value: "Europe/Amsterdam",
      },
      {
        label: "(GMT+01:00) Belgrade, Bratislava, Budapest, Ljubljana, Prague",
        value: "Europe/Belgrade",
      },
      {
        label: "(GMT+01:00) Brussels, Copenhagen, Madrid, Paris",
        value: "Europe/Brussels",
      },
      {
        label: "(GMT+01:00) Sarajevo, Skopje, Warsaw, Zagreb",
        value: "Europe/Sarajevo",
      },
      { label: "(GMT+01:00) West Central Africa", value: "Africa/Lagos" },
      { label: "(GMT+02:00) Amman", value: "Asia/Amman" },
      {
        label: "(GMT+02:00) Athens, Bucharest, Istanbul",
        value: "Europe/Athens",
      },
      { label: "(GMT+02:00) Beirut", value: "Asia/Beirut" },
      { label: "(GMT+02:00) Cairo", value: "Africa/Cairo" },
      { label: "(GMT+02:00) Harare, Pretoria", value: "Africa/Harare" },
      {
        label: "(GMT+02:00) Helsinki, Kyiv, Riga, Sofia, Tallinn, Vilnius",
        value: "Europe/Helsinki",
      },
      { label: "(GMT+02:00) Jerusalem", value: "Asia/Jerusalem" },
      { label: "(GMT+02:00) Minsk", value: "Europe/Minsk" },
      { label: "(GMT+02:00) Windhoek", value: "Africa/Windhoek" },
      { label: "(GMT+03:00) Kuwait, Riyadh, Baghdad", value: "Asia/Kuwait" },
      {
        label: "(GMT+03:00) Moscow, St. Petersburg, Volgograd",
        value: "Europe/Moscow",
      },
      { label: "(GMT+03:00) Nairobi", value: "Africa/Nairobi" },
      { label: "(GMT+03:00) Tbilisi", value: "Asia/Tbilisi" },
      { label: "(GMT+03:30) Tehran", value: "Asia/Tehran" },
      { label: "(GMT+04:00) Abu Dhabi, Muscat", value: "Asia/Muscat" },
      { label: "(GMT+04:00) Baku", value: "Asia/Baku" },
      { label: "(GMT+04:00) Yerevan", value: "Asia/Yerevan" },
      { label: "(GMT+04:30) Kabul", value: "Asia/Kabul" },
      { label: "(GMT+05:00) Yekaterinburg", value: "Asia/Yekaterinburg" },
      {
        label: "(GMT+05:00) Islamabad, Karachi, Tashkent",
        value: "Asia/Karachi",
      },
      {
        label: "(GMT+05:30) Chennai, Kolkata, Mumbai, New Delhi",
        value: "Asia/Calcutta",
      },
      { label: "(GMT+05:30) Sri Jayawardenapura", value: "Asia/Calcutta" },
      { label: "(GMT+05:45) Kathmandu", value: "Asia/Katmandu" },
      { label: "(GMT+06:00) Almaty, Novosibirsk", value: "Asia/Almaty" },
      { label: "(GMT+06:00) Astana, Dhaka", value: "Asia/Dhaka" },
      { label: "(GMT+06:30) Yangon (Rangoon)", value: "Asia/Rangoon" },
      { label: "(GMT+07:00) Bangkok, Hanoi, Jakarta", value: "Asia/Bangkok" },
      { label: "(GMT+07:00) Krasnoyarsk", value: "Asia/Krasnoyarsk" },
      {
        label: "(GMT+08:00) Beijing, Chongqing, Hong Kong, Urumqi",
        value: "Asia/Hong_Kong",
      },
      {
        label: "(GMT+08:00) Kuala Lumpur, Singapore",
        value: "Asia/Kuala_Lumpur",
      },
      { label: "(GMT+08:00) Irkutsk, Ulaan Bataar", value: "Asia/Irkutsk" },
      { label: "(GMT+08:00) Perth", value: "Australia/Perth" },
      { label: "(GMT+08:00) Taipei", value: "Asia/Taipei" },
      { label: "(GMT+09:00) Osaka, Sapporo, Tokyo", value: "Asia/Tokyo" },
      { label: "(GMT+09:00) Seoul", value: "Asia/Seoul" },
      { label: "(GMT+09:00) Yakutsk", value: "Asia/Yakutsk" },
      { label: "(GMT+09:30) Adelaide", value: "Australia/Adelaide" },
      { label: "(GMT+09:30) Darwin", value: "Australia/Darwin" },
      { label: "(GMT+10:00) Brisbane", value: "Australia/Brisbane" },
      {
        label: "(GMT+10:00) Canberra, Melbourne, Sydney",
        value: "Australia/Canberra",
      },
      { label: "(GMT+10:00) Hobart", value: "Australia/Hobart" },
      { label: "(GMT+10:00) Guam, Port Moresby", value: "Pacific/Guam" },
      { label: "(GMT+10:00) Vladivostok", value: "Asia/Vladivostok" },
      {
        label: "(GMT+11:00) Magadan, Solomon Is., New Caledonia",
        value: "Asia/Magadan",
      },
      { label: "(GMT+12:00) Auckland, Wellington", value: "Pacific/Auckland" },
      {
        label: "(GMT+12:00) Fiji, Kamchatka, Marshall Is.",
        value: "Pacific/Fiji",
      },
      { label: "(GMT+13:00) Nuku'alofa", value: "Pacific/Tongatapu" },
    ],
    start: new Date().toISOString().substr(0, 10),
    end: new Date().toISOString().substr(0, 10),
    color: "#ff0000",
    allDay: false,
    description: {
      time: 1550476186479,
      blocks: [
        {
          type: "paragraph",
          data: {
            text: "Click to start editing",
          },
        },
      ],
      version: "2.8.1",
    },
    event: {},
    menuColor: false,
    hidden: false,
    events: [],
    types: [{ name: "None", gameID: "" }],
    gamesType: "",
    editor: null,
    dialog: false,
  }),
  components: {
    dateTimePicker,
  },
  beforeMount() {
    this.getEvents();
  },
  mounted() {},
  watch: {
    description: function (newVal) {
      console.log(newVal);
    },
  },
  methods: {
    async saveEvent() {
      let self = this;

      this.editor.save().then((savedData) => {
        this.description = savedData;

        let utcDateStart = DateTime.fromISO(
          `${this.start}T${this.startTime}:${this.startMinutes}:00`,
          { zone: this.timeZone }
        );
        let utcDateEnd = DateTime.fromISO(
          `${this.end}T${this.endTime}:${this.endMinutes}:00`,
          { zone: this.timeZone }
        );

        db.collection("calendar")
          .doc(this.id)
          .set({
            name: this.name,
            calendarID: Math.floor(Math.random() * Date.now()),
            gamesID: this.gamesType,
            start: utcDateStart.toString(),
            end: utcDateEnd.toString(),
            timeZone: this.timeZone,
            color: this.color,
            description: this.description,
            allDay: this.allDay,
            hidden: false,
          })
          .then(() => {
            self.$router.push(`/calendar/`);
          });
      });
    },
    reset() {
      this.$router.push(`/calendar/`);
    },
    deleteEvent() {
      let self = this;
      this.editor.save().then((savedData) => {
        this.description = savedData;

        let utcDateStart = DateTime.fromISO(
          `${this.start}T${this.startTime}:${this.startMinutes}:00`,
          { zone: this.timeZone }
        );
        let utcDateEnd = DateTime.fromISO(
          `${this.end}T${this.endTime}:${this.endMinutes}:00`,
          { zone: this.timeZone }
        );

        db.collection("calendar")
          .doc(this.id)
          .set({
            name: this.name,
            calendarID: Math.floor(Math.random() * Date.now()),
            gamesID: this.gamesType,
            start: utcDateStart.toString(),
            end: utcDateEnd.toString(),
            timeZone: this.timeZone,
            color: this.color,
            description: this.description,
            allDay: this.allDay,
            hidden: false,
          })
          .then(() => {
            self.$router.push(`/calendar/`);
          });
      });
    },
    setupEditor() {
      this.editor = new EditorJS({
        readOnly: false,
        holder: `codex-editor`,
        autofocus: true,
        onReady: function () {
          console.log("ready");
        },
        data: this.description,
        tools: {
          header: {
            class: Header,
            shortcut: "CMD+SHIFT+H",
          },
          list: {
            class: List,
          },
          paragraph: {
            class: Paragraph,
            config: {
              placeholder: ".",
            },
          },
          image: {
            class: SimpleImage,
            inlineToolbar: true,
            config: {
              placeholder: "Paste image URL",
            },
          },
        },
        onChange: function () {},
      });
    },
    async getEvents() {
      this.events = [];
      let snapshot = await db.collection("events").get();
      this.events = snapshot.docs.map((doc) => {
        return {
          id: doc.id,
          ...doc.data(),
        };
      });
      this.events.forEach((element) => {
        this.types.push({ name: element.name, gameID: element.id });
      });

      db.collection("calendar")
        .where("calendarID", "==", parseInt(this.$route.params.eventid))
        .get()
        .then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            let data = doc.data();
            this.id = doc.id;
            this.allDay = data.allDay;
            this.calendarID = data.calendarID;
            this.color = data.color;
            this.description = data.description;
            this.gamesID = data.gamesID;
            this.name = data.name;
            this.timeZone = data.timeZone;

            let utcDateStart = DateTime.fromISO(data.start, {
              zone: data.timeZone,
            });
            let utcDateEnd = DateTime.fromISO(data.end, {
              zone: data.timeZone,
            });

            this.start = utcDateStart.toISODate();
            this.startTime =
              utcDateStart.get("hour") < 10
                ? "0" + utcDateStart.get("hour")
                : utcDateStart.get("hour");
            this.startMinutes =
              utcDateStart.get("minute") < 10
                ? "0" + utcDateStart.get("minute")
                : utcDateStart.get("minute");

            this.end = utcDateEnd.toISODate();
            this.endTime =
              utcDateEnd.get("hour") < 10
                ? "0" + utcDateEnd.get("hour")
                : utcDateEnd.get("hour");
            this.endMinutes =
              utcDateEnd.get("minute") < 10
                ? "0" + utcDateEnd.get("minute")
                : utcDateEnd.get("minute");

            this.hidden = data.hidden;
            this.setupEditor();
            this.gamesType = this.gamesID;
          });
        });
      // .catch((error) => {
      //   console.log("Error getting documents: ", error);
      // });
    },
  },
};
</script>

<style lang="scss">
a {
  text-decoration-line: none;
}
.services-list {
  .v-card {
    min-height: 250px;
  }
}
</style>
